import { useLocation } from "wouter";
import { useEffect } from "react";
import ReactGA from "react-ga4";

const usePageTracking = () => {
    const [location] = useLocation();

    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: location });
    }, [location]);
};

export default usePageTracking;
